import { Component, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, first, tap } from 'rxjs';
import { ErrorModel } from 'src/app/core/models/error-model.interface';
import { ResetPasswordData } from 'src/app/core/models/user/reset-password-data';
import { ResetPasswordFormModel } from 'src/app/core/models/user/reset-password-form.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { Convertor } from 'src/app/core/utils/convertor';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    providers: [ResetPasswordFormModel],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  formModel = inject(ResetPasswordFormModel);
  private readonly authService = inject(AuthService);
  private readonly toastService = inject(ToastService);
  private readonly translateService = inject(TranslateService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  @ViewChild('dangerTpl')
  public dangerTpl!: TemplateRef<unknown>;
  public callbackError?: string;

  @ViewChild('successTpl')
  public successTpl!: TemplateRef<unknown>;
  public message = '';

  // These fields just for ease of use on template
  public passwordFormControl: FormControl<string>;
  public confirmPasswordFormControl: FormControl<string>;

  private token = '';
  private email = '';

  constructor() {
    const formModel = this.formModel;

    this.passwordFormControl = formModel.form.controls.password;
    this.confirmPasswordFormControl = formModel.form.controls.confirmPassword;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.email = params['email'];
    });
  }

  public submitForm(): void {
    const requestModel: ResetPasswordData = {
      ...this.formModel.form.getRawValue(),
      token: this.token,
      email: this.email,
    };

    this.authService
      .resetPassword(requestModel)
      .pipe(
        first(),
        tap(() => {
          this.message = this.translateService.instant(
            'MESSAGES.PASSWORD_SUCCESSFULLY_RESTORED',
          );

          this.toastService.show({
            template: this.successTpl,
            className: 'bg-success text-light',
          });

          this.router.navigate(['/login']);
        }),
        catchError((error) => {
          const errorModel = error.error as ErrorModel;

          const i128nKey = Convertor.pascalToScreamingSnakeCase(
            errorModel.i18nKey,
          );
          const translatedMessage = this.translateService.instant(
            `ERRORS.${i128nKey}`,
          );

          this.callbackError = translatedMessage;

          this.toastService.show({
            template: this.dangerTpl,
            className: 'bg-danger text-light',
          });

          return EMPTY;
        }),
      )
      .subscribe();
  }
}
